module.exports = {
      id: "icon-audio-next-usage",
      viewBox: "0 0 35.504 35.504",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-audio-next",
      toString: function () {
        return this.url;
      }
    }